class AccountPopup extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      accountPopupClose: '[data-account-popup-close]',
      accountPopupItem: '[data-account-popup-item]',
      accountPopupLogout: '[data-account-popup-logout]',
      accountPopupToggle: '[data-account-popup-toggle]'
    };

    this.classes = {
      active: 'active',
      hidden: 'hidden',
      loading: 'loading'
    };

    this.data = {
      accountPopupToggle: 'accountPopupToggle'
    };

    this.forms = this.querySelectorAll('form');
    this.popupClose = this.querySelector(this.selectors.accountPopupClose);
    this.popupLogout = this.querySelector(this.selectors.accountPopupLogout);
    this.popupToggles = this.querySelectorAll(this.selectors.accountPopupToggle);
    this.popupTriggers = [...document.querySelectorAll('a[href*="/account"')].filter(pt => !pt.closest('account-popup'));

    this.initEvents();
    
  }

  initEvents() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.forms?.forEach(f => f.addEventListener('submit', this.onFormSubmit.bind(this)));
    this.popupClose.addEventListener('click', this.close.bind(this));
    this.popupLogout?.addEventListener('click', this.logout.bind(this));
    this.popupToggles?.forEach(pt => pt.addEventListener('click', this.switchWindows.bind(this)));
    this.popupTriggers?.forEach(pt => pt.addEventListener('click', this.open.bind(this)));
    
  }

  onFormSubmit(e) {
    const form = e.target;
    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton.getAttribute('aria-disabled') === 'true') return;
    submitButton.setAttribute('aria-disabled', true);

    submitButton.classList.add(this.classes.loading);
    submitButton.querySelector('.loading__spinner').classList.remove(this.classes.hidden);
    
  }

  switchWindows(e) {
    const target = e.currentTarget;
    const currentWindow = target.closest(this.selectors.accountPopupItem);
    const nextWindow = document.getElementById(target.dataset[this.data.accountPopupToggle]);

    currentWindow.classList.add(this.classes.hidden);
    nextWindow.classList.remove(this.classes.hidden);
    
  }

  logout(e) {
    e.preventDefault();
    const logoutButton = e.currentTarget;
    const href = logoutButton.getAttribute('href');

    logoutButton.classList.add(this.classes.loading);
    logoutButton.querySelector('.loading__spinner').classList.remove(this.classes.hidden);

    fetch(href)
      .then(response => {
        console.log(response);
        if (!response.ok) throw new Error('Logout failed');
      })
      .finally(() => {
        this.close();
        window.location.href = window.location.href;
      });
  }

  open(e) {
    e.preventDefault();
    const trigger = e.currentTarget;

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.addEventListener('click', this.onBodyClick);
    });

  }

  onBodyClick = (e) => {
    if (
      this === e.target ||
      this.contains(e.target)
    ) return;

    this.close();
  }

  close() {
    this.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
  }
  
}

customElements.define('account-popup', AccountPopup);